/**
 * EthPending - Official TypeScript/JavaScript client for EthPending API
 * 
 * Stream Ethereum pending transactions in real-time via WebSocket or HTTP polling.
 * 
 * @packageDocumentation
 */

// Main clients
export { WebSocketClient } from './WebSocketClient';
export { HTTPClient } from './HTTPClient';

// Utilities
export { FilterManager } from './FilterManager';
export { ConnectionManager } from './ConnectionManager';
export { MetricsCollector } from './utils/metrics';
export {
  calculateDelay,
  shouldRetry,
  sleep,
  retryWithBackoff,
  createRetryStrategy,
  DEFAULT_RETRY_OPTIONS,
} from './utils/retry';

// Type exports
export type {
  PendingTransaction,
  TransactionLog,
  ConnectedMessage,
  SubscribedMessage,
  PendingTxMessage,
  ErrorMessage,
  WebSocketMessage,
  FilterOptions,
  HTTPResponse,
  ClientConfig,
  Metrics,
  RetryOptions,
  WebSocketClientEvents,
  HTTPClientEvents,
} from './types';

export {
  ConnectionState,
  EthPendingError,
  ConnectionError,
  ApiError,
  RateLimitError,
  AuthenticationError,
} from './types';

// Version
export const VERSION = '1.0.0';

